import styled from "styled-components";

export const StyledDrawingArea = styled.div`
  height: 100%;
  border: 1px solid grey;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  background-color: rgba(255, 255, 255, 0.075);
`;
